import { createRoot } from 'react-dom/client';
import { useEffect, useState } from 'react';
import { IntroPlayStopButton } from '@/components/IntroPlayStopButton.jsx';

/** @type {((patch: Partial<{ playing: boolean; disabled: boolean }>) => void) | null} */
let setButtonState = null;

/**
 * @param {{ onToggle: () => void; initialPlaying?: boolean; initialDisabled?: boolean }} props
 */
function IntroPlayStopRoot({ onToggle, initialPlaying = false, initialDisabled = false }) {
  const [playing, setPlaying] = useState(initialPlaying);
  const [disabled, setDisabled] = useState(initialDisabled);

  useEffect(() => {
    setButtonState = (patch) => {
      if ('playing' in patch) setPlaying(Boolean(patch.playing));
      if ('disabled' in patch) setDisabled(Boolean(patch.disabled));
    };
    return () => {
      setButtonState = null;
    };
  }, []);

  return (
    <IntroPlayStopButton playing={playing} disabled={disabled} onToggle={onToggle} />
  );
}

/**
 * @param {HTMLButtonElement} button
 * @param {{ onToggle: () => void }} options
 */
export function mountIntroPlayStop(button, { onToggle }) {
  const mount = document.createElement('span');
  mount.style.display = 'contents';
  button.replaceWith(mount);

  createRoot(mount).render(
    <IntroPlayStopRoot
      onToggle={onToggle}
      initialPlaying={button.dataset.state === 'playing'}
      initialDisabled={button.disabled}
    />
  );

  return {
    /** @param {boolean} playing */
    sync(playing) {
      setButtonState?.({ playing });
    },
    /** @param {boolean} disabled */
    setDisabled(disabled) {
      setButtonState?.({ disabled });
    },
  };
}
